
import { BasicDialogHandler } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2AntiCheatEvent } from "../../../event/Poker2AntiCheatEvent";
import { Poker2TourTableWinDialog } from "../../../view/dialogs/tournament/Poker2TourTableWinDialog";
import { Poker2TourTableWinDialogProperties } from "../../../view/dialogs/tournament/Poker2TourTableWinDialogProperties";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2SoundController } from "../../Poker2SoundController";
import { Poker2Command } from "../Poker2Command";

export class JTECommand extends Poker2Command {
    protected get cmdId(): string {
        return "jte";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            BasicDialogHandler.getInstance().registerDialogs("Poker2TourTableWinDialog", new Poker2TourTableWinDialogProperties(paramObj.round, this.bindFunction(this.leaveToLobby)), true, BasicDialogHandler.PRIORITY_TOP);

            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_WIN);
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    private leaveToLobby(): void {
        if (this.layoutManager.currentState == 10) {
            BasicDialogHandler.getInstance().blockDialogs = false;
            BasicModel.smartfoxClient.sendMessage("tle", []);
            this.controller.dispatchEvent(new Poker2AntiCheatEvent("antiCheatRemoveConnection"));
        }
        this.layoutManager.state = 11;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
